import { render, staticRenderFns } from "./ManageFundings.vue?vue&type=template&id=94356f0a&"
import script from "./ManageFundings.vue?vue&type=script&lang=js&"
export * from "./ManageFundings.vue?vue&type=script&lang=js&"
import style0 from "./ManageFundings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports